import {
  durationFormatError,
  parseDurationFormValue,
} from './dateTime';

/** Spread is always expected work plus lunch break. No fixed durations. */
export function spreadMinutesFromDurations(
  expectedWorkMinutes: number,
  lunchBreakMinutes: number,
): number {
  return expectedWorkMinutes + lunchBreakMinutes;
}

export function matchingSpreadMinutes(
  expectedWorkMinutes: number,
  lunchBreakMinutes: number,
  spreadMinutes: number,
): boolean {
  return (
    spreadMinutes ===
    spreadMinutesFromDurations(expectedWorkMinutes, lunchBreakMinutes)
  );
}

/** Parse a duration form field (Xh Ym / Xm). Empty → null. */
export function minutesFromFormValue(value: string): number | null {
  if (!value.trim()) return null;
  return parseDurationFormValue(value);
}

export function liveSpreadMinutes(
  expectedWorkMinutes: string,
  lunchBreakMinutes: string,
): number | null {
  const expected = minutesFromFormValue(expectedWorkMinutes);
  const lunch = minutesFromFormValue(lunchBreakMinutes);
  if (expected == null || expected <= 0 || lunch == null || lunch < 0) {
    return null;
  }
  return spreadMinutesFromDurations(expected, lunch);
}

export function parseNonNegativeDuration(
  value: string,
  label: string,
): number | string {
  if (value.trim() === '') return 0;
  const parsed = parseDurationFormValue(value);
  if (parsed === null) return durationFormatError(label);
  return parsed;
}

export function parsePositiveDuration(
  value: string,
  label: string,
): number | string {
  const parsed = parseDurationFormValue(value);
  if (parsed === null || parsed <= 0) {
    return `${label} must use format like 30m or 08h 30m and be greater than 0.`;
  }
  return parsed;
}
